import { render, staticRenderFns } from "./ChildrenPrivacyProtection.vue?vue&type=template&id=595c552b&scoped=true&"
import script from "./ChildrenPrivacyProtection.vue?vue&type=script&lang=js&"
export * from "./ChildrenPrivacyProtection.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenPrivacyProtection.vue?vue&type=style&index=0&id=595c552b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c552b",
  null
  
)

export default component.exports